import { defauleFilterQuery } from './const'
import { ELanguage } from '@/common'
import { buildCompanyUrl, buildJobUrl } from '@/helpers'
import { IJobDetail, TJob } from '@/services/jobs/type'

export const getFilterQueryJobsSeach = (
    companyId: number,
    excludeJobId: number,
    userId: string | null,
    retrieveFields?: string[],
    limit?: number
) => {
    const newFilter = {
        ...defauleFilterQuery,
        ...(userId ? { userId: parseInt(userId) } : undefined),
        ...(limit ? { hitsPerPage: limit } : undefined),
        filter: [
            ...defauleFilterQuery.filter,
            {
                field: 'companyId',
                value: `${companyId}`
            }
        ],
        exclude: [
            {
                field: 'jobId',
                value: `${excludeJobId}`
            }
        ],
        ...(retrieveFields ? { retrieveFields: retrieveFields } : undefined)
    }
    return newFilter
}

export const encodeToken = (str: string, key: string) => {
    let myBuffer: number[] = []
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i) + key.charCodeAt(i % key.length)
        myBuffer = myBuffer.concat([code])
    }
    return Buffer.from(myBuffer).toString('base64')
}

export function formattedJob(
    jobs: Partial<TJob>[],
    langCode: ELanguage | undefined = ELanguage.VI,
    utm?: string
): Partial<IJobDetail>[] {
    const newJobs = jobs.map((item) => {
        let locationText = ''
        if (item.workingLocations) {
            locationText = (item.workingLocations || [])
                .map((item: any) =>
                    langCode === ELanguage.VI ? item.cityNameVI : item.cityName
                )
                .join(', ')
        } else if (item.locations) {
            locationText =
                langCode === ELanguage.VI
                    ? item.locations[1].join(', ')
                    : item.locations[2].join(', ')
        }
        return {
            ...item,
            jobTitle: item.jobTitle,
            jobId: item.jobId,
            jobUrl: buildJobUrl({
                alias: item.alias ?? '',
                jobId: item.jobId ?? 0,
                langCode,
                utm
            }),
            companyLogo: item.companyLogo,
            company: item.companyName,
            companyUrl: buildCompanyUrl({
                companyId: item.companyId ?? 0,
                companySlug: item.companyName,
                langCode
            }),
            jobLevelText:
                langCode === ELanguage.VI ? item.jobLevelVI : item.jobLevel,
            jobLevelId: item.jobLevelId,
            address: item.address,
            jobDescription: item.jobDescription,
            jobRequirement: item.jobRequirement,
            isAnonymous: item.isAnonymous,
            locationText: locationText,
            prettySalary: item.prettySalary
        }
    })
    return newJobs
}
